<template>
  <div class="card-type-1" :class="(size || 'w1') + ' ' + (line || 'h1')">
    <div class="card-content">
      <div class="card-header">
        <p>
          {{ name }}
          <slot name="refresh" />
          <a v-if="mark" class="mark type1 ongoing">{{ mark }}</a>
        </p>
        <router-link :to="href" class="fl-right more">
          <span>{{ more || '자세히 보기' }}</span>
          <i class="arrow right"></i>
        </router-link>
      </div>
      <slot />
    </div>
    <slot name="footer" />
  </div>
</template>

<script>
export default {
  name: "DashboardContainer",
  props: ["mark", "name", "href", "size", "line", "more", "onRefresh"]
};
</script>
